// Updated Profile.js for compatibility with project API and structure
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import styles from "./Profile.module.css";
import { useNavigate } from "react-router-dom";
import { useUpdateUserMutation, useGetUserAssignedItemsQuery } from "../../redux/slices/usersApiSlice";
import logo from "../../assets/svgs/tevhidlogo.svg";
import Modal from "../../components/Layout/Modal";
import { BiSolidUser } from "react-icons/bi";
import { FaChevronLeft } from "react-icons/fa";

const Profile = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showModal, setShowModal] = useState(false);

  const [updateUser, { isLoading }] = useUpdateUserMutation();
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { data: userAssignedItems } = useGetUserAssignedItemsQuery(userInfo._id, {
    refetchOnMountOrArgChange: true,
  });

  // Atanmış kayıtlar { item: { type }, count } şeklindedir; türe göre adetleri topla
  const stockByType = (type) =>
    (userAssignedItems || [])
      .filter((ai) => ai.item?.type === type)
      .reduce((sum, ai) => sum + (ai.count || 0), 0);

  const closeModal = () => {
    setShowModal(false);
    setCurrentPassword("");
    setPassword("");
    setConfirmPassword("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Yeni şifre en az 6 karakter olmalıdır");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Yeni şifreler eşleşmedi");
      return;
    }
    try {
      await updateUser({ currentPassword, password }).unwrap();
      toast.success("Şifreniz değiştirildi");
      closeModal();
    } catch (error) {
      toast.error(error?.data?.message || "Şifre değiştirilemedi");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.containerHeader}>
        <button onClick={() => navigate('/')} className={styles.backBtn}>
          <FaChevronLeft size={25} />
        </button>
        <div className={styles.profilePart}>
          <h1>{userInfo?.name}</h1>
          <button>
            <BiSolidUser size={20} />
          </button>
        </div>
      </div>
      <div className={styles.main}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Logo" className={styles.logo} />
        </div>
        <div className={styles.stockInfo}>
          <p>Kitap Stok Miktarı: {stockByType('book')}</p>
          <p>Dergi Stok Miktarı: {stockByType('magazine')}</p>
          <p>Çocuk Dergisi Stok Miktarı: {stockByType('childrenMagazine')}</p>
        </div>
        <div className={styles.userInfo}>
          <div className={styles.userInfoBox}>
            <p>Kullanıcı:</p>
            <h2>{userInfo.name}</h2>
          </div>
          <div className={styles.userInfoBox}>
            <p>Email:</p>
            <p>{userInfo.email}</p>
          </div>
          <div className={styles.userInfoBox}>
            <p>Rol:</p>
            <p>{userInfo.isSuperAdmin ? "Super Admin" : "User"}</p>
          </div>
          <button
            className={styles.updateButton}
            onClick={() => setShowModal(true)}
          >
            Şifremi Değiştir
          </button>
        </div>
      </div>
      <Modal isOpen={showModal} onClose={closeModal} title="Şifremi Değiştir">
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label>Mevcut Şifre</label>
            <input
              type="password"
              autoComplete="current-password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <label>Yeni Şifre (en az 6 karakter)</label>
            <input
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <label>Yeni Şifre (Tekrar)</label>
            <input
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className={styles.submitButton} disabled={isLoading}>
            {isLoading ? "Kaydediliyor..." : "Şifreyi Değiştir"}
          </button>
        </form>
      </Modal>
    </div>
  );
};

export default Profile;
